// extracted by mini-css-extract-plugin
module.exports = {"gradient":"tabs_gradient__3H7Gp","tabsList":"tabs_tabsList__34RFY","tab":"tabs_tab__xx9z8"};